import * as React from "react";
import styled from "styled-components";
import { Button, Select } from "antd";

const Container = styled.div`
  padding: 30px 20px 0 10px;
  height: 300px;
  .cameraSelect {
    width: 280px;
    margin: 10px 0;
  }
  video {
    width: 500px;
    height: 280px;
    margin-bottom: 5px;
    background: black;
  }
`;

const AudioSetting: React.FunctionComponent = () => {
  const [inputs, setInputs] = React.useState([]);
  const [outputs, setOutputs] = React.useState([]);
  // const [current, setCurrent] = React.useState(undefined);

  const checkDevice = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const inputsDevices = devices.filter(
      (device) => device.kind === "audioinput"
    );
    const outputsDevices = devices.filter(
      (device) => device.kind === "audiooutput"
    );
    setInputs(inputsDevices);
    setOutputs(outputsDevices);
  };

  React.useEffect(() => {
    checkDevice();
  }, []);

  return (
    <>
      <Container>
        <div className="mt30">Микрофон</div>
        <div>
          <Select
            placeholder="Микрофоноо сонгоно уу"
            // onChange={(v) => setCurrent(v)}
            // value={current}
            className="cameraSelect"
          >
            {inputs.map((d) => (
              <Select.Option value={d.deviceId} key={d.deviceId}>
                {d.label || d.deviceId}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="mt30">Спикер</div>
        <div>
          <Select
            placeholder="Спикерээ сонгоно уу"
            // onChange={(v) => setCurrent(v)}
            // value={current}
            className="cameraSelect"
          >
            {outputs.map((d) => (
              <Select.Option value={d.deviceId} key={d.deviceId}>
                {d.label || d.deviceId}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Container>
    </>
  );
};

export default AudioSetting;
